import { addBusinessDays } from 'date-fns';
import format from 'date-fns/format';
import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
export function formatDateISO(value) {
    const date = ensureDate(value);
    return date.toISOString();
}
export function formatDate(value, formatString = 'MMMM do yyyy') {
    const date = ensureDate(value);
    return format(date, formatString);
}
export function ensureDate(value) {
    let date = value;
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return date;
}
export function ensureBusinessDay(value, excludedDates) {
    let date = ensureDate(value);
    const day = date.getDay();
    // Is weekend, move to next business day
    if (day === 0 || day === 6) {
        date = addBusinessDays(date, 1);
    }
    if (excludedDates) {
        if (!permittedDate(date, excludedDates)) {
            do {
                date = addBusinessDays(date, 1);
            } while (!permittedDate(date, excludedDates));
        }
    }
    return date;
}
export function permittedDate(value, excludedDates) {
    for (const excludedDate of excludedDates) {
        const startDate = excludedDate.isRecurring
            ? new Date(excludedDate.startDate).setFullYear(value.getFullYear())
            : new Date(excludedDate.startDate);
        const endDate = excludedDate.isRecurring
            ? new Date(excludedDate.endDate).setFullYear(value.getFullYear())
            : new Date(excludedDate.endDate);
        if (!isBefore(value, startDate) && !isAfter(value, endDate)) {
            return false;
        }
    }
    return true;
}
